import { ChangeDetectionStrategy, Component, OnInit, input } from '@angular/core';
import { User } from '@sentry/browser';
import { Observable } from 'rxjs';
import { isSiteEmbedded } from 'src/app/extensions/dot-cms/utils/dot-cms-utils';

import { AccountFacade } from 'ish-core/facades/account.facade';
import { AppFacade } from 'ish-core/facades/app.facade';
import { DeviceType } from 'ish-core/models/viewtype/viewtype.types';

@Component({
  selector: 'custom-login-status',
  templateUrl: './custom-login-status.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CustomLoginStatusComponent implements OnInit {
  readonly logoutOnly = input(false);
  readonly view = input<'auto' | 'small' | 'full'>('auto');
  user$: Observable<User>;
  showLink$: Observable<boolean>;

  deviceType$: Observable<DeviceType>;
  constructor(private accountFacade: AccountFacade, private appFacade: AppFacade) {}

  ngOnInit() {
    this.user$ = this.accountFacade.user$;
    this.deviceType$ = this.appFacade.deviceType$;
    this.showLink$ = this.accountFacade.showLoginStatus();
  }

  getViewClasses(): string {
    switch (this.view()) {
      case 'auto':
        return 'd-none d-md-inline';
      case 'full':
        return 'd-inline';
      case 'small':
        return 'd-none';
    }
  }
  isInsideIframe(): boolean {
    return isSiteEmbedded();
  }
}
